import { getPaginationLimit } from '@autovia-uk/polaris-components/sharedPartials/getPaginationLimit';
import IndexTemplate from './ComposedIndexTemplate';
import { IndexPageQuery } from './IndexQuery.graphql';

IndexTemplate.query = IndexPageQuery;
IndexTemplate.queryVars = getPaginationLimit;

export default IndexTemplate;
